import {
  Component,
  OnInit,
  ViewChild,
  ElementRef
} from "@angular/core";
import { CommonService, CacService } from "../../../services";
import * as _ from "lodash";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import * as fromCommonStore from "../../../store";
import * as fromRootStore from "../../../reducers";
import swal from "sweetalert2";
import * as _moment from 'moment';

const moment = _moment;
@Component({
  selector: "branch-meeting",
  templateUrl: "./branchMeeting.component.html"
})
export class branchMeetingComponent implements OnInit {
  subscribeAuth;
  sourceList = [];
  branchList: any[];
  // meetingReferenceId: any;
  filterData: { branch: string; branch_id: number; date: Date; };
  filterExpand: boolean;
  comments: any;
  branchOption: any;
  referenceTypeOption: any;
  referenceOption: any;
  walkinReferenceOption: any;
  aspReferenceOption: any;
  conReferenceOption: any;
  referenceMajorOption: any;
  branchCtrl = new FormControl();
  monthCtrl = new FormControl();
  referenceTypeCtrl = new FormControl();
  referenceCtrl = new FormControl();
  walkinReferenceCtrl = new FormControl();
  aspReferenceCtrl = new FormControl();
  conReferenceCtrl = new FormControl();
  referenceMajorCtrl = new FormControl();
  imList = ['Yes', 'No'];
  referenceTypeList: any;
  referenceList: any;
  gridRow: any;

  // TRAGET DETAILS
  @ViewChild('input_number') input_number: ElementRef;
  @ViewChild('input_text') input_text: ElementRef;
  targetColumn: any = [];
  targetRow: any = [];

  // SOURCE DETAILS
  @ViewChild('sourceInput') sourceInput: ElementRef;
  @ViewChild('sourceSelect') sourceSelect: ElementRef;
  @ViewChild('sourceRowInput') sourceRowInput: ElementRef;
  @ViewChild('deleteSourceButton') deleteSourceButton: ElementRef;
  @ViewChild('addSourceButton') addSourceButton: ElementRef;
  sourceColumn: any = [];
  sourceRow: any = [];
  sourceModal = {
    source: '',
    month_target: '',
    days_target: '',
    achived: '',
    yes_no: '',
    reason: '',
    conversion: '',
    asp: '',
    bilateral: ''
  };
  sourceAddBtn: boolean;

  // WALKIN DETAILS
  @ViewChild('walkinInput') walkinInput: ElementRef;
  @ViewChild('walkinSelect') walkinSelect: ElementRef;
  @ViewChild('walkinRowInput') walkinRowInput: ElementRef;
  @ViewChild('deleteWalkinButton') deleteWalkinButton: ElementRef;
  @ViewChild('addWalkinButton') addWalkinButton: ElementRef;
  @ViewChild('walkinImportantSelect') walkinImportantSelect: ElementRef;
  walkinColumn: any = [];
  walkinRow: any = [];
  walkinModal = {
    source: '',
    month_target: '',
    important: '',
    days_target: '',
    achived: '',
    yes_no: '',
    reason: '',
    noofhat: '',
    conversion: ''
  };
  walkinAddBtn: boolean;


  // ASP DETAILS
  @ViewChild('aspInput') aspInput: ElementRef;
  @ViewChild('aspSelect') aspSelect: ElementRef;
  @ViewChild('aspRowInput') aspRowInput: ElementRef;
  @ViewChild('deleteAspButton') deleteAspButton: ElementRef;
  @ViewChild('addAspButton') addAspButton: ElementRef;
  @ViewChild('aspImportantSelect') aspImportantSelect: ElementRef;
  aspColumn: any = [];
  aspRow: any = [];
  aspModal = {
    source: '',
    month_target: '',
    important: '',
    days_target: '',
    achived: '',
    yes_no: '',
    reason: '',
    avg_sales_mrp: ''
  };
  aspAddBtn: boolean;


  // CONVERSION COLUMN
  @ViewChild('conversionInput') conversionInput: ElementRef;
  @ViewChild('conversionSelect') conversionSelect: ElementRef;
  @ViewChild('conversionRowInput') conversionRowInput: ElementRef;
  @ViewChild('deleteConversionButton') deleteConversionButton: ElementRef;
  @ViewChild('addConversionButton') addConversionButton: ElementRef;
  @ViewChild('conversionImportantSelect') conversionImportantSelect: ElementRef;

  conversionColumn: any = [];
  conversionRow: any = [];
  conversionModal = {
    source: '',
    month_target: '',
    important: '',
    days_target: '',
    achived: '',
    yes_no: '',
    reason: '',
    noofhat: '',
    noofsold: '',
    conversion: ''
  };
  conversionAddBtn: boolean;

  // BILATERAL ETAILS
  @ViewChild('bilateralInput') bilateralInput: ElementRef;
  @ViewChild('bilateralSelect') bilateralSelect: ElementRef;
  @ViewChild('bilateralRowInput') bilateralRowInput: ElementRef;
  @ViewChild('deleteBilateralButton') deleteBilateralButton: ElementRef;
  @ViewChild('addBilateralButton') addBilateralButton: ElementRef;
  @ViewChild('bilateralImportantSelect') bilateralImportantSelect: ElementRef;

  bilateralColumn: any = [];
  bilateralRow: any = [];
  bilateralModal = {
    source: '',
    month_target: '',
    important: '',
    days_target: '',
    achived: '',
    yes_no: '',
    reason: '',
    blper: ''
  }
  bilateralAddBtn: boolean;
  loading: boolean;
  tempBranchId: any;
  userType: any;
  canEdit: boolean = true;

  constructor(
    private commonService: CommonService,
    public store: Store<fromRootStore.State>,
    private cacService: CacService,
  ) {
    //  FILTER PROPERTIES
    this.filterData = {
      branch: "All",
      branch_id: -1,
      date: new Date()
    };

    // this.meetingReferenceId = [];
    this.referenceTypeList = [];
    this.referenceList = [];

    this.subscribeAuth = this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
      if (auth['islogin']) {
        if(this.userType == 'Super_Admin' || this.userType == 'Admin' || this.userType == 'Accounts'){
          this.canEdit = false;
        }
        this.userType = auth['usertype'];
        this.tempBranchId = auth['branch_id'];
      }
    });
  }

  ngOnInit() {

    
    this.getReferenceTypeList();
    this.getReferenceList();
    // BRANCH LIST PROPERTIES
    this.branchList = [];
    this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
      this.branchList.push({ 'branch_id': -1, 'branch_name': "All" });
      res.data.map(branchObj => {
        if (branchObj.is_crm_branch == 'Yes' && branchObj.branch_name != 'HEAD OFFICE')
          this.branchList.push(branchObj);
      });
      this.filterData.branch_id = this.tempBranchId;
      this.branchCtrl.disable();
      if(this.userType == 'Super_Admin' || this.userType == 'Admin' || this.userType == 'Accounts'){
        this.canEdit = false;
        this.filterData.branch_id = -1;
        this.branchCtrl.enable();
      }
      
      
    });

    this.applyFilter();
  

    this.branchOption = this.branchCtrl.valueChanges
      .startWith("")
      .map(name => (name ? this.filterBranch(name) : this.branchList.slice()));

    this.referenceOption = this.referenceCtrl.valueChanges
      .startWith("")
      .map(name => (name ? this.filterReference(name) : this.referenceList.slice()));

    this.walkinReferenceOption = this.walkinReferenceCtrl.valueChanges
      .map(name => (name ? this.filterReference(name) : this.referenceList.slice()));

    this.aspReferenceOption = this.aspReferenceCtrl.valueChanges
      .map(name => (name ? this.filterReference(name) : this.referenceList.slice()));
    
    this.conReferenceOption = this.conReferenceCtrl.valueChanges
      .map(name => (name ? this.filterReference(name) : this.referenceList.slice())); 
      
    this.referenceTypeOption = this.referenceTypeCtrl.valueChanges
      .startWith("")
      .map(name => (name ? this.filterReferenceType(name) : this.referenceTypeList.slice()));

    

  }

  // BRANCH LIST PROPERTIES
  displayBranch(item_id: number) {
    if (item_id && this.branchList.length > 0) {
      let fitem: any = _.find(this.branchList, { branch_id: item_id }),
        ref_name = fitem.branch_name ? fitem.branch_name : "";
      return ref_name;
    }
    return "";
  }

  filterBranch(name: string) {
    name = _.escapeRegExp(name);
    return this.branchList.filter(ha =>
      new RegExp(name, "gi").test(ha.branch_name)
    );
  }
  // --------------------------------

  displayReferenceType(name: number) {
    if (name && this.referenceTypeList.length > 0) {
      let fitem: any = _.find(this.referenceTypeList, { reference_type: name }),
        ref_name = fitem.reference_type ? fitem.reference_type : "";
      return ref_name;
    }
    return "";
  }

  filterReferenceType(name: string) {
    name = _.escapeRegExp(name);
    return this.referenceTypeList.filter(ha =>
      new RegExp(name, "gi").test(ha.reference_type)
    );
  }

  displayReference(modal, name: number) {
    if (name && this.referenceList.length > 0) {
      let fitem: any = _.find(this.referenceList, { name: name }),
        ref_name = fitem.name ? fitem.name : "";
      if (ref_name) {
        switch (modal) {
          case 'walkin':
            this.walkinModal['ref_id'] = fitem.ref_id;
            break;
          case 'conversion':
            this.conversionModal['ref_id'] = fitem.ref_id;
            break;
          case 'bilateral':
            this.bilateralModal['ref_id'] = fitem.ref_id;
            break;
          case 'asp':
            this.aspModal['ref_id'] = fitem.ref_id;
            break;
        };
      }
      return ref_name;
    }
    return "";
  }

  filterReference(name: string) {
    name = _.escapeRegExp(name);
    return this.referenceList.filter(ha =>
      new RegExp(name, "gi").test(ha.name)
    );
  }

  resetFilter() {
    this.filterData = {
      branch: "All",
      branch_id: -1,
      date: new Date()
    };
  }

  applyFilter() {
    this.filterExpand = false;
    this.initTargetDetails();
    this.initSourceDetails();
    this.initWalkinDetails();
    this.initConversionDetails();
    this.initASPDetails();
    this.initBilateralDetails();
    // this.getmeetingReportSource();
    this.getMeetingData();
  }

  // REFERENCE LIST
  getReferenceTypeList() {
    this.commonService.getReferenceTypeList().subscribe(res => {
      this.referenceTypeList = res.data;
    });
  }
  getReferenceList() {
    this.store.select(fromCommonStore.getAllReference).subscribe((res: any) => {
      if (_.isEmpty(res)) {
        return;
      }
      this.referenceList = res;
    });
  }

  // // GET MEETING RESOURCE VALUES
  // getmeetingReportSource() {
  //   let param = {
  //     branch_id: (this.filterData.branch_id) ? this.filterData.branch_id : -1,
  //     month: moment(this.filterData.date).format('YYYY-MM'),
  //   }

  //   this.cacService.getMeetingReportSources(param).then(res => {
  //     this.meetingReferenceId = res;
  //   });
  // }

  // TARGET DETAILS
  initTargetDetails() {
    this.targetColumn = [
      { name: 'Type', prop: 'source', width: 50 },
      { name: 'Month Target', prop: 'month_target', cell_template: true, cell_template_element: this.input_number, cell_align: 'right', width: 50 },
      { name: this.getColumnTitle(), prop: 'days_target', cell_align: 'right', width: 50 },
      { name: 'Achived', prop: 'achived', cell_align: 'right', width: 50 },
      { name: 'Yes-No', prop: 'yes_no', width: 20 },
      { name: 'Reason', prop: 'reason', cell_template: true, cell_template_element: this.input_text, width: 180 }
    ];

    this.targetRow = [
      { source: 'Value', month_target: '', days_target: '', achived: '', yes_no: '', reason: '' },
      { source: 'Walkin', month_target: '', days_target: '', achived: '', yes_no: '', reason: '' },
      { source: 'Conversion %', month_target: '', days_target: '', achived: '', yes_no: '', reason: '' },
      { source: 'ASP', month_target: '', days_target: '', achived: '', yes_no: '', reason: '' }
    ];
  }

  // SOURCE DETAILS
  initSourceDetails() {
    this.sourceColumn = [
      { name: 'Major Sources', prop: 'source', custom_row: true, custom_row_element: this.sourceSelect, width: 50 },
      { name: 'Month Target', prop: 'month_target', custom_row: true, custom_row_element: this.sourceRowInput, cell_template: true, cell_template_element: this.sourceInput, width: 50 },
      { name: this.getColumnTitle(), prop: 'days_target', custom_row: true, cell_align: 'right', width: 50, innerScroll: true },
      { name: 'Achived', prop: 'achived', custom_row: true, cell_align: 'right', width: 50, innerScroll: true },
      { name: 'Yes-No', prop: 'yes_no', custom_row: true, width: 20, innerScroll: true },
      { name: 'Reason', prop: 'reason', cell_template: true, cell_template_element: this.sourceInput, custom_row: true, width: 120, innerScroll: true },
      { name: 'Conversion %', prop: 'conversion', custom_row: true, cell_align: 'right', width: 50, innerScroll: true },
      { name: 'ASP', prop: 'asp', custom_row: true, cell_align: 'right', width: 50, innerScroll: true },
      { name: 'Bilateral', prop: 'bilateral', custom_row: true, cell_align: 'right', width: 50, innerScroll: true },
      { name: 'Options', prop: 'option', cell_template: true, cell_template_element: this.deleteSourceButton, custom_row: true, custom_row_element: this.addSourceButton, cell_align: 'center', width: 30 }
    ];
  }
  resetSource() {
    this.sourceModal = {
      source: '',
      month_target: '',
      days_target: '',
      achived: '',
      yes_no: '',
      reason: '',
      conversion: '',
      asp: '',
      bilateral: ''
    };
    this.sourceAddBtn = true;
  }

  // WALKIN DETAILS
  initWalkinDetails() {
    this.walkinColumn = [
      { name: 'DR.Name', prop: 'source', custom_row: true, custom_row_element: this.walkinSelect, width: 50 },
      { name: 'DD-Important', prop: 'important', custom_row: true, custom_row_element: this.walkinImportantSelect, width: 50 },
      { name: 'Month Target', prop: 'month_target', custom_row: true, custom_row_element: this.walkinRowInput, cell_template: true, cell_template_element: this.walkinInput, cell_align: 'right', width: 50, sumRow: true },
      { name: this.getColumnTitle(), prop: 'days_target', custom_row: true, cell_align: 'right', width: 50, sumRow: true, innerScroll: true },
      { name: 'Achived', prop: 'achived', custom_row: true, cell_align: 'right', width: 50, sumRow: true, innerScroll: true },
      { name: 'Yes-No', prop: 'yes_no', custom_row: true, width: 20, innerScroll: true },
      { name: 'Reason', prop: 'reason', cell_template: true, cell_template_element: this.walkinInput, custom_row: true, width: 120, innerScroll: true },
      { name: 'No.Of HAT', prop: 'noofhat', custom_row: true, cell_align: 'right', width: 50, sumRow: true, innerScroll: true },
      { name: 'No.Of Sold', prop: 'noofsold', custom_row: true, cell_align: 'right', width: 50, sumRow: true, innerScroll: true },
      { name: 'Conversion %', prop: 'conversion', custom_row: true, cell_align: 'right', width: 50, sumRow: true, innerScroll: true },
      { name: 'Options', prop: 'option', cell_template: true, cell_template_element: this.deleteWalkinButton, custom_row: true, custom_row_element: this.addWalkinButton, cell_align: 'center', width: 30 }
    ];
  }
  resetWalkin() {
    this.walkinModal = {
      source: '',
      month_target: '',
      important: '',
      days_target: '',
      achived: '',
      yes_no: '',
      reason: '',
      noofhat: '',
      conversion: ''
    };
    this.walkinAddBtn = true;

  }

  // ASP DETAILS
  initASPDetails() {
    this.aspColumn = [
      { name: 'DR.Name', prop: 'source', custom_row: true, custom_row_element: this.aspSelect, width: 50 },
      { name: 'DD-Important', prop: 'important', custom_row: true, custom_row_element: this.aspImportantSelect, width: 50 },
      { name: 'Month Target', prop: 'month_target', custom_row: true, custom_row_element: this.aspRowInput, cell_template: true, cell_template_element: this.aspInput, width: 50 },
      { name: this.getColumnTitle(), prop: 'days_target', custom_row: true, cell_align: 'right', width: 50, innerScroll: true },
      { name: 'Achived', prop: 'achived', custom_row: true, cell_align: 'right', width: 50, innerScroll: true },
      { name: 'Yes-No', prop: 'yes_no', custom_row: true, width: 20, innerScroll: true },
      { name: 'Reason', prop: 'reason', cell_template: true, cell_template_element: this.aspInput, custom_row: true, cell_align: 'right', width: 120, innerScroll: true },
      { name: 'Total Value', prop: 'avg_sales_mrp', custom_row: true, cell_align: 'right', width: 50, innerScroll: true },
      { name: 'Options', prop: 'option', cell_template: true, cell_template_element: this.deleteAspButton, custom_row: true, custom_row_element: this.addAspButton, cell_align: 'center', width: 30 }
    ];
  }
  resetAsp() {
    this.aspModal = {
      source: '',
      month_target: '',
      important: '',
      days_target: '',
      achived: '',
      yes_no: '',
      reason: '',
      avg_sales_mrp: ''
    };
    this.aspAddBtn = true;
  }

  // CONVERSION DETAILS
  initConversionDetails() {
    this.conversionColumn = [
      { name: 'DR.Name', prop: 'source', custom_row: true, custom_row_element: this.conversionSelect, width: 50 },
      { name: 'DD-Important', prop: 'important', custom_row: true, custom_row_element: this.conversionImportantSelect, width: 50 },
      { name: 'Month Target', prop: 'month_target', custom_row: true, custom_row_element: this.conversionRowInput, cell_template: true, cell_template_element: this.conversionInput, width: 50 },
      { name: this.getColumnTitle(), prop: 'days_target', custom_row: true, cell_align: 'right', width: 50, innerScroll: true },
      { name: 'Achived', prop: 'achived', custom_row: true, cell_align: 'right', width: 50, innerScroll: true },
      { name: 'Yes-No', prop: 'yes_no', custom_row: true, width: 20, innerScroll: true },
      { name: 'Reason', prop: 'reason', cell_template: true, cell_template_element: this.conversionInput, custom_row: true, width: 120, innerScroll: true },
      { name: 'No.Of HAT', prop: 'noofhat', custom_row: true, cell_align: 'right', width: 50, innerScroll: true },
      { name: 'No.Of Sold', prop: 'noofsold', custom_row: true, cell_align: 'right', width: 50, innerScroll: true },
      { name: 'Conversion %', prop: 'conversion', custom_row: true, cell_align: 'right', width: 50, innerScroll: true },
      { name: 'Options', prop: 'option', cell_template: true, cell_template_element: this.deleteConversionButton, custom_row: true, custom_row_element: this.addConversionButton, cell_align: 'center', width: 30 }
    ];
  }
  resetConversion() {
    this.conversionModal = {
      source: '',
      month_target: '',
      important: '',
      days_target: '',
      achived: '',
      yes_no: '',
      reason: '',
      noofhat: '',
      noofsold: '',
      conversion: ''
    };
    this.conversionAddBtn = true;
  }

  // BILATERAL DETAILS
  initBilateralDetails() {
    this.bilateralColumn = [
      { name: 'DR.Name', prop: 'source', custom_row: true, custom_row_element: this.bilateralSelect, width: 50 },
      { name: 'DD-Important', prop: 'important', custom_row: true, custom_row_element: this.bilateralImportantSelect, width: 50 },
      { name: 'Month Target %', prop: 'month_target', custom_row: true, custom_row_element: this.bilateralRowInput, cell_template: true, cell_template_element: this.bilateralInput, cell_align: 'right', width: 50, sumRow: true },
      { name: this.getColumnTitle() + '%', prop: 'days_target', custom_row: true, cell_align: 'right', width: 50, innerScroll: true },
      { name: 'Achived %', prop: 'achived', custom_row: true, cell_align: 'right', width: 50, innerScroll: true },
      { name: 'Yes-No', prop: 'yes_no', custom_row: true, width: 20, innerScroll: true },
      { name: 'Reason', prop: 'reason', cell_template: true, cell_template_element: this.bilateralInput, custom_row: true, width: 120, innerScroll: true },
      { name: 'B-L qty', prop: 'blqty', custom_row: true, cell_align: 'right', width: 35, innerScroll: true },
      { name: 'Options', prop: 'option', cell_template: true, cell_template_element: this.deleteBilateralButton, custom_row: true, custom_row_element: this.addBilateralButton, cell_align: 'center', width: 30 }
    ];
  }
  resetBilateral() {
    this.bilateralModal = {
      source: '',
      month_target: '',
      important: '',
      days_target: '',
      achived: '',
      yes_no: '',
      reason: '',
      blper: ''
    };
    this.bilateralAddBtn = true;
  }

  getColumnTitle() {
    return this.getDateCount(this.filterData.date) + ' Days Target';
  }

  daysTarget(monthTarget) {
    let totDays = this.getDateCount(this.filterData.date, 1);
    return this.num_format((monthTarget * this.getDateCount(this.filterData.date)) / totDays);
  }

  getAchieved(row) {
    var res = 0;
    switch (row.type) {
      case 'Value':

        break;
      case 'Walkin':

        break;
      case 'Coversion':

        break;
      case 'ASP':

        break;
    };
    return res;
  }

  isAchieved(val1, val2) {
    var flag = 'No';
    if (val1 < val2)
      flag = 'Yes';
    return flag;
  }

  // ADD ROWS
  addRow(type) {
    switch (type) {
      case 'source':
        if (!this.checkIsExist(this.sourceRow, { ...this.sourceModal })) {
          this.sourceRow.push({ ...this.sourceModal });
        } else {
          swal("WARNING", "Already Exist!!", 'warning');
        }
        this.resetSource();
        break;
      case 'walkin':
        if (!this.checkIsExist(this.walkinRow, { ...this.walkinModal })) {
          this.walkinRow.push({ ...this.walkinModal });
        } else {
          swal("WARNING", "Already Exist!!", 'warning');
        }
        this.resetWalkin();
        break;
      case 'asp':
        if (!this.checkIsExist(this.aspRow, { ...this.aspModal })) {
          this.aspRow.push({ ...this.aspModal });
        } else {
          swal("WARNING", "Already Exist!!", 'warning');
        }
        this.resetAsp();
        break;
      case 'conversion':
        if (!this.checkIsExist(this.conversionRow, { ...this.conversionModal })) {
          this.conversionRow.push({ ...this.conversionModal });
        } else {
          swal("WARNING", "Already Exist!!", 'warning');
        }
        this.resetConversion();
        break;
      case 'bilateral':
        if (!this.checkIsExist(this.bilateralRow, { ...this.bilateralModal })) {
          this.bilateralRow.push({ ...this.bilateralModal });
        } else {
          swal("WARNING", "Already Exist!!", 'warning');
        }
        this.resetBilateral();
        break;
    }
  }

  validateRow(type) {
    switch (type) {
      case 'source':
        if (!this.sourceModal.month_target || !this.sourceModal.source)
          this.sourceAddBtn = true;
        else
          this.sourceAddBtn = false;
        break;
      case 'walkin':
        if (!this.walkinModal.month_target || !this.walkinModal.source || !this.walkinModal.important)
          this.walkinAddBtn = true;
        else
          this.walkinAddBtn = false;
        break;
      case 'asp':
        if (!this.aspModal.month_target || !this.aspModal.source || !this.aspModal.important)
          this.aspAddBtn = true;
        else
          this.aspAddBtn = false;
        break;
      case 'conversion':
        if (!this.conversionModal.month_target || !this.conversionModal.source || !this.conversionModal.important)
          this.conversionAddBtn = true;
        else
          this.conversionAddBtn = false;
        break;
      case 'bilateral':
        if (!this.bilateralModal.month_target || !this.bilateralModal.source || !this.bilateralModal.important)
          this.bilateralAddBtn = true;
        else
          this.bilateralAddBtn = false;
        break;
    }
  }

  checkIsExist(rowArr, data) {
    let flag = false;
    if (rowArr.find(res => res.source == data.source)) {
      flag = true;
    }
    return flag;
  }

  // DELETE COLUMN
  DeleteRow(type, ind) {
    switch (type) {
      case 'source':
        this.sourceRow.splice(ind, 1);
        break;
      case 'walkin':
        this.walkinRow.splice(ind, 1);
        break;
      case 'asp':
        this.aspRow.splice(ind, 1);
        break;
      case 'conversion':
        this.conversionRow.splice(ind, 1);
        break;
      case 'bilateral':
        this.bilateralRow.splice(ind, 1);
        break;
    }
  }

  // CALCULATE REPORT
  calculateReport() {
    let param = {
      branch_id: this.filterData.branch_id,
      month: moment(this.filterData.date).format('YYYY-MM'),
      targetDate: this.getDateCount(this.filterData.date),
      targetDet: JSON.stringify(this.targetRow),
      sourceDet: JSON.stringify(this.sourceRow),
      walkinDet: JSON.stringify(this.walkinRow),
      conversionDet: JSON.stringify(this.conversionRow),
      aspDet: JSON.stringify(this.aspRow),
      bilateralDet: JSON.stringify(this.bilateralRow),
      comments: this.comments
    };
    this.loading = true;
    this.cacService.calculateMeetingData(param).then(res => {
      if (res) {
        this.targetRow = res.level1;
        this.sourceRow = res.level2;
        this.walkinRow = res.level3;
        this.conversionRow = res.level4;
        this.aspRow = res.level5;
        this.bilateralRow = res.level6;
        this.loading = false;
      }
    });

  }

  // GET REPORT
  getMeetingData() {
    this.loading = true;
    let param = {
      branch_id: this.filterData.branch_id,
      month: moment(this.filterData.date).format('YYYY-MM')
    };
    this.cacService.getMeetingData(param).then(res => {
      this.targetRow = (res['Target Details']) ? res['Target Details'] : this.targetRow;
      this.sourceRow = (res['Source Details']) ? res['Source Details'] : [];
      this.conversionRow = (res['Conversion Details']) ? res['Conversion Details'] : [];
      this.aspRow = (res['ASP Details']) ? res['ASP Details'] : [];
      this.walkinRow = (res['Walkin Details']) ? res['Walkin Details'] : [];
      this.bilateralRow = (res['Bilateral Details']) ? res['Bilateral Details'] : [];
      this.calculateReport();
    });
  }

  // SAVE REPORT 
  saveReport() {
    if (!this.filterData.branch_id || !this.filterData.date) {
      swal("INFO", "Must Select The Filter", 'info');
    } else {
      let param = {
        branch_id: this.filterData.branch_id,
        month: moment(this.filterData.date).format('YYYY-MM'),
        targetDet: JSON.stringify(this.targetRow),
        sourceDet: JSON.stringify(this.sourceRow),
        walkinDet: JSON.stringify(this.walkinRow),
        conversionDet: JSON.stringify(this.conversionRow),
        aspDet: JSON.stringify(this.aspRow),
        bilateralDet: JSON.stringify(this.bilateralRow),
        comments: this.comments
      };
      let that = this;
      swal({
        type: 'warning',
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: "Yes",
        text: "Are you sure want to save this?"
      }).then(res => {
        this.cacService.saveMeetingData(param).then(res => {
          if (res.success) {
            swal('SUCCESS', res.message, 'success');
            that.calculateReport();
          } else {
            swal('ERROR', res.message, 'error');
          }
        }).catch(res => {
          swal('ERROR', res.message, 'error');
        });
      });
    }
  }

  downloadExcel() {
    // let target = [...this.targetColumn],
    //   source = [...this.sourceColumn],
    //   asp = [...this.aspColumn],
    //   walkin = [...this.walkinColumn],
    //   conversion = [...this.conversionColumn],
    //   bilateral = [...this.bilateralColumn];
    let param = {
      title: 'Branch Meeting Report',
      branch_id: this.filterData.branch_id,
      month: moment(this.filterData.date).format('YYYY-MM'),
      target_day: this.getDateCount(this.filterData.date),
      Target_Details: JSON.stringify(this.removeGridTemplate(this.targetColumn)),
      Source_Details: JSON.stringify(this.removeGridTemplate(this.sourceColumn)),
      Walkin_Details: JSON.stringify(this.removeGridTemplate(this.walkinColumn)),
      ASP_Details: JSON.stringify(this.removeGridTemplate(this.aspColumn)),
      Conversion_Details: JSON.stringify(this.removeGridTemplate(this.conversionColumn)),
      Bilateral_Details: JSON.stringify(this.removeGridTemplate(this.bilateralColumn))
    };
    let that = this;
    this.commonService
      .exportDynamicExcel(param)
      .then(function (res: any) {
         that.applyFilter();
        if (res['_body']) {
          that.filterExpand = false;
          var headers = res['headers']["_headers"],
            ctype = headers.get('content-type')[0],
            cdispos = headers.get('content-disposition')[0],
            filename = cdispos.replace(/attachment;filename=|"/gi, ''),
            blob = new Blob([res['_body']], {
              type: ctype
            }),
            link = document.createElement('a');

          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        } else {
          that.applyFilter();
          var toast = {
            type: 'error',
            title: 'ERROR',
            body: res.message
          };
          //that.toasterService.pop(toast);
        }
      });
  }







  num_format(num) {
    return num.toFixed(2);
  }

  getDateCount(date, cnt = 0) {
    var now = new Date(date),
      month = now.getMonth(),
      year = now.getFullYear(),
      cur_date: any = new Date().getDate() -1;
    if (new Date().getMonth() != month || cnt == 1) {
      cur_date = 0;
    }
    return new Date(year, month, cur_date).getDate();
  }

  removeGridTemplate(data) {
    let temp = [...data];
    temp.map(res => {
      if (res.custom_row_element) {
        res.custom_row_element = "";
      }
      if (res.cell_template_element) {
        res.cell_template_element = "";
      }
    });
    return temp;
  }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/management/branch-meeting/branchMeeting.component.ts